import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { ThemeRandomizer } from '@/components/ui/theme-randomizer';
import { cn } from '@/lib/utils';

interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className }) => {
  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigationItems = [
    { label: 'About', id: 'about' },
    { label: 'Experience', id: 'experience' },
    { label: 'Education', id: 'education' },
    { label: 'Projects', id: 'projects' },
    { label: 'Skills', id: 'skills' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header
      className={cn(
        'sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        className
      )}
    >
      <div className='container mx-auto flex h-16 items-center justify-between px-4'>
        {/* Logo/Name */}
        <div className='flex items-center space-x-2'>
          <h1
            className='text-xl font-bold text-foreground cursor-pointer hover:text-primary transition-colors duration-200'
            onClick={() => scrollToSection('hero')}
          >
            Jeremy Marino
          </h1>
          <span className='text-sm text-muted-foreground hidden sm:inline'>
            Senior Software Engineer
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className='hidden md:flex items-center space-x-1'>
          {navigationItems.map(item => (
            <Button
              key={item.id}
              variant='ghost'
              size='sm'
              onClick={() => scrollToSection(item.id)}
              className='text-sm font-medium transition-colors hover:text-foreground'
            >
              {item.label}
            </Button>
          ))}
        </nav>

        {/* Theme Controls */}
        <div className='flex items-center gap-2'>
          <ThemeToggle size='sm' />
          <ThemeRandomizer size='sm' variant='ghost' />

          {/* Mobile Menu Button */}
          <div className='md:hidden'>
            <Button
              variant='ghost'
              size='sm'
              className='h-9 w-9 p-0'
              aria-label='Toggle menu'
            >
              <Menu className='h-4 w-4' />
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu - Hidden by default, will be enhanced later */}
      <div className='hidden md:hidden border-t bg-background'>
        <nav className='container mx-auto px-4 py-4'>
          <div className='flex flex-col space-y-2'>
            {navigationItems.map(item => (
              <Button
                key={item.id}
                variant='ghost'
                size='sm'
                onClick={() => scrollToSection(item.id)}
                className='justify-start text-sm font-medium'
              >
                {item.label}
              </Button>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
